import { Flex, Col,} from "antd";
import aboutimg from "../../assets/aboutus.png";
import Testimonial from "./Testimonial";
import FindEmployee from "./FindEmployee";
import { useState, useEffect } from "react";


const AboutPage = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 769);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 640);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      <div className="max-w-6xl md:py-20 mx-auto md:px-0 px-4">
        <div className="pt-10 pb-12 md:pt-10 md:pb-10 flex-col space-y-14 md:mb-10">
          <div className="md:px-32 px-4 flex-col space-y-8">
            <h1
              className="text-2xl md:text-[3.3rem] font-black mb-0 md:mb-4 md:leading-[1.075]"
              data-aos="zoom-y-out"
            >
              <span className="text-green-600">About Us: </span>
              We Lived the Problem. Then We Solved It.
            </h1>

            <p className="font-normal md:text-lg text-sm text-justify text-border leading-6">
              For ten years, we burned the midnight oil at Anweshan, a public health consulting firm obsessed with data that saves lives. But here’s the dirty secret no one talks about: hiring great enumerators was a nightmare.
            </p>

            <p className="font-normal md:text-lg text-sm tracking-wide text-border text-justify leading-6">
              We’d post jobs. Pray. Then drown in a flood of mismatched resumes. Spend weeks verifying skills. Cross fingers that hires wouldn’t ghost mid-project. Every bottleneck delayed research. Every mediocre hire risked data integrity. We were experts in public health—not HR heroes.
            </p>
          </div>
          <div className="md:px-32 px-4 flex-col space-y-8">
            <h1
              className="text-3xl md:text-5xl font-black md:mb-2 tracking-wide text-green-600"
              data-aos="zoom-y-out"
            >
              Enough.
            </h1>

            <p className="font-normal md:text-lg text-sm text-border text-justify leading-6">
              Fed up with the chaos, we teamed up with Neural Grid Labs—tech wizards who laugh at “impossible.” Together, we asked: What if hiring enumerators felt less like rolling dice and more like launching a precision missile?
            </p>
          </div>
        </div>
        <div className="pt-20 pb-12 md:pt-10 md:pb-20 flex-col space-y-20 md:mb-20 mx-4 md:mx-15">
          <div className="md:px-32 px-4 flex-col space-y-8">
            <h1
              className="text-3xl md:text-[3.3rem] font-black mb-0 md:mb-4 md:leading-[1.075]"
              data-aos="zoom-y-out"
            >
              <span className="text-green-600">HireEnumerators.com </span>
              was born.
            </h1>
            <Flex vertical={isMobile} className="bg-[#edf6f1] p-0 drop-shadow-2xl rounded-md md:flex-row ">
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <img alt="#" src={aboutimg} className="h-full w-full" />
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <div className="flex-col md:mx-8 md:my-32 align-middle space-y-11 my-10 mx-5">
                  <p className="font-normal md:text-lg text-xs md:tracking-wide text-border text-justify md:leading-tight">
                    This isn’t some faceless algorithm. It’s a rebellion against broken systems, built by people who’ve sweated through fieldwork themselves. We baked Anweshan’s decade of hard-won hiring scars (yes, scars) into Neural Grid’s tech—creating a platform that does the heavy lifting so you don’t have to.
                  </p>
                  <p className="font-normal md:text-lg text-xs sm:text-justify md:tracking-wide text-border md:leading-tight">
                    Today, we serve everyone from gritty NGOs to government giants. Why? Because bad data isn’t just a spreadsheet error. It’s villages missing vaccines. Policies built on guesswork. Wasted budgets.
                  </p>
                </div>
              </Col>
            </Flex>
          </div>
        </div>
        <div className="flex-col md:px-32 px-4 sm:mb-10">
          <h1
            className="text-3xl md:text-5xl font-black md:leading-[1.075] tracking-wide text-green-600"
            data-aos="zoom-y-out"
          >
            Our mission
          </h1>
          <p className="font-medium md:text-lg text-sm tracking-wide text-border">
            To connect organizations with the best enumerators in the fastest, most efficient way possible.
          </p>
          <br />
          <p className="font-medium md:text-lg text-sm tracking-wide text-border">
            <span className="text-green-600"> For recruiters: </span>Stop hiring enumerators. Start deploying them.
          </p>
          <p className="font-medium md:text-lg text-sm tracking-wide text-border">
            <span className="text-green-600"> For enumerators: </span>Find work that respects your craft.
          </p>
        </div>
      </div>

      <div className="p-8 bg-primary px-5 md:px-0">
        <div className="max-w-6xl mx-auto">
          <div className="md:px-20 text-white flex-col space-y-8">
            <p
              className="md:text-2xl text-md font-medium tracking-wide mt-2"
              data-aos="zoom-y-out"
              data-aos-delay="150"
            >
              No fluff. No empty promises. Just a platform forged in the trenches,
              <br /> designed to turn “what if” into what’s next.
            </p>
            <p
              className="md:text-2xl text-md font-medium tracking-wide mt-2"
              data-aos="zoom-y-out"
              data-aos-delay="150"
            >
              Welcome to the future of enumerator hiring. Welcome to HireEnumerators.com.
            </p>
          </div>
        </div>
      </div>

      <div className="max-w-6xl md:py-14 mx-auto px-5 md:px-0">
        <div className="pt-16 pb-12 md:pt-14 md:pb-14 flex-col space-y-32 md:mb-10 mx-4 md:mx-15">
          <div className="md:px-32 px-4 flex-col space-y-10">
            <h1
              className="text-3xl md:text-5xl font-black md:mb-4 md:leading-[1.075] tracking-wide"
              data-aos="zoom-y-out"
            >
              <span className="text-green-600">Our Commitment</span>
              <br />
              To independence
            </h1>
            <div className="flex-col space-y-6">
              <p className="font-normal md:text-lg text-sm text-justify text-border leading-5 mt-3">
                Let’s cut through the noise: Yes, Anweshan birthed HireEnumerators.com. But like any good parent, we knew when to let go.
              </p>
              <p className="font-normal md:text-lg text-sm text-justify text-border leading-6">
                This platform isn’t Anweshan’s side project—it’s a fiercely independent entity run by a team obsessed with fairness, not favors. No backdoor deals. No data shortcuts. No “special access” for anyone, including us. Why? Because trust isn’t earned through lip service—it’s built by refusing to play god with your results.
              </p>
            </div>
            <div className="flex-col space-y-6">
              <p className="font-medium md:text-lg text-sm tracking-wide text-primary text-justify">
                Our rules are non-negotiable:.
              </p>
              <p className="font-normal md:text-lg text-sm tracking-wide text-border text-justify leading-6">
                Recruiters get raw talent, untainted by bias. <br />
                Enumerators get judged solely on skill, not who they know. <br />
                Every match is powered by merit, not backroom handshakes. <br />
                We’re not here to gatekeep. We’re here to dismantle gatekeeping. <br />
              </p>
              <p className="font-normal md:text-lg text-sm tracking-wide text-border text-justify leading-6">
                This is a platform for the gritty, the principled, the ones who’d rather fail honestly than win dirty. Whether you’re a scrappy NGO or a government titan, you get the same ironclad promise: No favorites. No agendas. Just cold, hard competence.
              </p>
            </div>
          </div>
          <div className="md:px-32 px-4 mt-14">
            <h1
              className="text-3xl md:text-5xl font-black mb-0 md:mb-4 md:leading-[1.075] tracking-wide"
              data-aos="zoom-y-out"
            >
              <span className="text-primary"> HireEnumerators.com </span>
              doesn’t serve Anweshan. It serves the truth.
            </h1>
          </div>
        </div>
      </div>

      <Testimonial />
      <FindEmployee />
    </>
  );
};

export default AboutPage;